// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".lXA0DfhWyc4isxL6{font-size:12px;line-height:16px;color:#949494}", "",{"version":3,"sources":["webpack://./../../libs/innova-components/src/lib/components/SubLabel/SubLabel.module.scss","webpack://./../../libs/innova-components/src/lib/assets/scss/_variables.scss"],"names":[],"mappings":"AAEA,kBACE,cCsCO,CDrCP,gBAAA,CACA,aCEO","sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"subLabel": "lXA0DfhWyc4isxL6"
};
export default ___CSS_LOADER_EXPORT___;
